<template>
    <div class="info-wrapper">
        <div class="back-icon" @click="goBack">
            <img src="../../assets/imgs/title_back.png" />
        </div>

        <div class="userinfo">
            <img :src="bgImg" class="avatar-background" :class="bgFilter" />
            <img :src="avatarUrl" class="layzload" style="display:none;" />
            <avatar
                :username="username"
                :textAvatar="username.slice(-1)"
                :avatarUrl="avatarUrl"
                :avatarBorder="true"
                :color="color"
                class="avatar"
            />
        </div>
        <div class="option-wrapper">
            <div class="option border-bottom" @click="checkTeamList">
                <div class="content-wrapper">
                    <img class="icon" src="../../assets/imgs/check_team.png" />切换团队
                </div>
            </div>
            <div class="option border-bottom" @click="goKefu">
                <div class="content-wrapper">
                    <img class="icon" src="../../assets/imgs/feedback.png" />意见反馈
                </div>
            </div>
            <div class="option border-bottom" @click="signOutDialog">
                <div class="content-wrapper">
                    <img class="icon" src="../../assets/imgs/sign_out.png" />退出登录
                </div>
            </div>
        </div>
        <div class="version">
            <p><span class="link" @click="goSecretsPage('serverAgreement')">《服务协议》</span>|<span class="link" @click="goSecretsPage('secrets')">《隐私协议》</span></p>
            © 2019 蓝湖
            <div class="num">{{ version }}</div>
        </div>
        <lanhu-dialog
            :showCancelButton="true"
            :content="dialogText"
            :handleConfirm="signOut"
            confirmButtonText="确定"
            ref="dialog"
        />
        <actionsheet :actions="actions" ref="actionsheet" />
    </div>
</template>
<style lang="scss" scoped>
.info-wrapper {
    background: #fff;
    position: relative;
    width: 100%;
    height: 100%;
    .back-icon {
        z-index: 10;
        opacity: 0.7;
        position: absolute;
        top: 1.37rem;
        padding: 0.5rem;
        left: 0.2rem;
        border: 0.1rem solid transparent;
        box-sizing: border-box;
        background-origin: content-box;
        img {
            width: 0.9rem;
        }
    }
    .userinfo {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 12rem;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        .avatar {
            position: relative;
            top: -0.5rem;
            width: 4.2rem;
            height: 4.2rem;
        }
        .avatar-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            left: 0;
            top: 0;
        }
        .avatar-background.bg-filter {
            filter: blur(30px);
        }
    }
    .option-wrapper {
        z-index: 1;
        .option:active {
            background-color: #edeff1;
        }
        .option {
            position: relative;
            height: 3.2rem;
            font-size: 0;
            .content-wrapper {
                position: absolute;
                margin-left: 1rem;
                font-size: 0.9rem;
                font-weight: 400;
                color: rgba(136, 136, 136, 1);
                line-height: 3.2rem;
                .icon {
                    display: inline-block;
                    position: relative;
                    opacity: 0.7;
                    top: 2px;
                    width: 0.9rem;
                    height: 0.93em;
                    margin-right: 0.15rem;
                }
            }
        }
    }
    .version {
        p {
            margin-bottom: 10px;
            .link {
                 color: #436ef3;
            }
        }
        .num {
            position: relative;
            top: 0.2rem;
            width: 100%;
        }
        text-align: center;
        position: fixed;
        bottom: 1.5rem;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 0.6rem;
        font-weight: 400;
        color: rgba(136, 136, 136, 1);
        line-height: 0.6rem;
    }
}
</style>
<script>
import avatar from "@/components/common/Avatar"
import lanhuDialog from "../../components/common/lanhu-dialog"
import actionsheet from "../../components/common/Actionsheet"
// import settingsData from '../../settings.js'
import API from "@/api/api.js"

export default {
    name: "userInfo",
    components: {
        avatar,
        lanhuDialog,
        actionsheet
    },
    data() {
        return {
            username: "",
            avatarUrl: "",
            color: "",
            dialogText: "确认退出登录？",
            actions: [],
            sheetVisible: false,
            imgFilter: false
        }
    },
    computed: {
        version() {
            if (isWebview && !location.origin.includes(`${window.domain}`)) {
                return localStorage.version ? localStorage.version : ""
            } else {
                return ""
            }
        },
        bgFilter() {
            if (this.avatarUrl && this.avatarUrl !== "null" && this.imgFilter) {
                return "bg-filter"
            } else {
                return false
            }
        },
        bgImg() {
            if (this.color == "red") {
                return require("../../assets/imgs/color/red.png")
            } else if (this.color == "blue") {
                return require("../../assets/imgs/color/blue.png")
            } else if (this.color == "green") {
                return require("../../assets/imgs/color/green.png")
            } else if (this.color == "purple") {
                return require("../../assets/imgs/color/purple.png")
            } else if (this.color == "orange") {
                return require("../../assets/imgs/color/orange.png")
            } else if (this.color == "cyan") {
                return require("../../assets/imgs/color/cyan.png")
            }
        }
    },
    mounted() {
        this.color = localStorage.color
        localStorage.itemPageAvatar = "true"
        this.username = localStorage.name
        if (localStorage.avatar !== "null") this.avatarUrl = localStorage.avatar
        this.$nextTick(() => {
            this.lazyLoad()
        })
    },
    methods: {
        goSecretsPage(routeName){
            this.$router.push({name:routeName})
        },

        lazyLoad() {
            var _this = this
            let img = document.querySelector(".avatar-background")
            let originImg = document.querySelector(".layzload")
            // 安全性检测
            const url = originImg.src ? originImg.src : ""
            if (!url) return
            originImg.onload = function() {
                img.src = url
                _this.imgFilter = true
            }
        },
        goBack() {
            this.$router.push({
                name: "team"
            })
        },
        goKefu() {
            if (isWebview && system == "ios") {
                let ref = cordova.InAppBrowser.open("https://lanhu.kf5.com/kchat", "_system", "location=yes")
            } else {
                this.$router.push({
                    name: "kefu"
                })
            }
        },
        async checkTeam(team_id, team_name, cloud_type, team_type) {
            localStorage.teamId = team_id
            localStorage.teamName = team_name
            localStorage.cloudType = cloud_type
            localStorage.teamType = team_type
            let res = await API.account.getUserInfo()
            localStorage.name = res.data.name
            await this.$root.remark.getTeamMemberName()

            this.$router.push({
                name: "team",
                query: {
                    team_id
                }
            })
            MtaH5.clickStat("switch_team")
        },
        async checkTeamList() {
            this.$root.eventBus.$emit("showLoading")
            let teams = await API.team.getTeams()

            this.actions = []
            teams.result.map(key => {
                this.actions.push({
                    name: key.name,
                    team_id: key.id,
                    cloud_type: key.cloud_type,
                    team_type: key.type,
                    method: () => {
                        this.checkTeam(key.id, key.name, key.cloud_type, key.type)
                    }
                })
            })

            this.$root.eventBus.$emit("hideLoading")
            this.$refs.actionsheet.open()
            this.sheetVisible = true
        },
        signOutDialog() {
            this.$refs.dialog.openDialog()
        },
        storageInit() {
            let teamCache = {}
            teamCache[localStorage.userId] = {
                teamId: localStorage.teamId,
                role: localStorage.role,
                teamName: localStorage.teamName,
                cloudType: localStorage.cloudType,
                type: localStorage.teamType
            }
            localStorage.teamCache = JSON.stringify(teamCache)

            localStorage.token = ""
            localStorage.name = ""
            localStorage.color = ""
            localStorage.email = ""
            localStorage.avatar = ""
            localStorage.teams = ""
            localStorage.teamId = ""
            localStorage.role = ""
            localStorage.teamName = ""
            localStorage.userId = ""
            localStorage.itemPageAvatar = ""
            localStorage.baseURL = ""
            localStorage.cloudType = ""
            localStorage.teamType = ""
        },
        async signOut() {
            await API.account.logout()
            this.storageInit()
            this.$root.eventBus.$emit("resetSetting")

            this.$router.replace({
                path: "/user"
            })
            this.$refs.dialog.close()
        }
    }
}
</script>
